import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link2, Check } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

export default function PartnerInviteLinkCard() {
  const { user } = useAuth();
  const [linkCopied, setLinkCopied] = useState(false);

  const showPartnerLink =
    !!(user?.referralCode) &&
    (user?.userType === "Shipper" ||
      (user?.userType === "Broker" &&
        (user?.membershipTier === "Paid" || user?.membershipTier === "Annual")));

  const partnerInviteLink = showPartnerLink
    ? `${window.location.origin}/join/${user?.referralCode}`
    : "";

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(partnerInviteLink);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch {
      // fallback: select the input text — browser clipboard access denied
    }
  };

  if (!showPartnerLink) return null;

  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 mb-1">
        <Link2 className="w-5 h-5 text-muted-foreground" />
        <h2 className="text-xl font-semibold">Your Partner Invite Link</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-5">
        Share this link with carriers or brokers who reach out to you — they'll be automatically
        connected as a partner when they join.
        {user?.userType === "Broker" && (
          <> This feature is included in your <span className="font-medium text-foreground">Search, Bid &amp; Post</span> plan.</>
        )}
      </p>
      <div className="flex items-center gap-2">
        <Input
          readOnly
          value={partnerInviteLink}
          className="bg-muted font-mono text-sm"
          data-testid="input-partner-invite-link"
        />
        <Button
          variant="outline"
          onClick={handleCopyLink}
          className="flex-shrink-0 min-w-[90px]"
          data-testid="button-copy-partner-link"
        >
          {linkCopied ? (
            <>
              <Check className="w-4 h-4 mr-1.5 text-green-600" />
              Copied!
            </>
          ) : (
            <>
              <Link2 className="w-4 h-4 mr-1.5" />
              Copy
            </>
          )}
        </Button>
      </div>
    </Card>
  );
}
